import DOMPurify from 'dompurify';
export const customCall = () => {
	return 1 + 1;
};

export function sanitizeHTML(html :any) {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li',
      'br', 'blockquote', 'code', 'pre', 'span', 'div','img','table', 'tr', 'td', 'th'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style','src', 'alt', 'title', 'width', 'height', 'colspan', 'rowspan', 'data-mention', 'data-user-id'],
    ALLOW_DATA_ATTR: false, // disallow data-* attributes (can hide payloads)
  });
}

export function detectBashScript(value: string): boolean {
  if (!value) return false;
  
  return (
    /#!\/bin\/(bash|sh|zsh|ksh|csh|fish)/i.test(value) ||
    /\b(sudo|chmod|rm\s+-rf|curl.*\|.*bash|wget.*\|.*sh)\b/i.test(value)
  );
}

export function removeBashScriptPatterns(value: string): string {
  if (!value) return '';
  
  let cleanValue = value;
  cleanValue = cleanValue.replace(/#!\/bin\/(bash|sh|zsh|ksh|csh|fish)/gi, '');
  cleanValue = cleanValue.replace(/\b(sudo|chmod)\s+/gi, '');
  
  return cleanValue;
}

const DANGEROUS_TAG_PATTERN = /<\s*\/?\s*(script|iframe|object|embed|style|form|input)\b/i;
const DANGEROUS_ATTR_PATTERN = /\b(onerror|onclick|onload|onmouseover|onfocus|onblur|onchange|onsubmit)\s*=/i;

export function sanitizeWithBashCheck(value: string): { sanitized: string; hasBash: boolean; hasOtherDanger: boolean } {
  if (!value) return { sanitized: '', hasBash: false, hasOtherDanger: false };

  const hasBash = detectBashScript(value);
  const cleanedValue = removeBashScriptPatterns(value);

  const hasDangerousContent = DANGEROUS_TAG_PATTERN.test(cleanedValue) || DANGEROUS_ATTR_PATTERN.test(cleanedValue);

  const sanitized = DOMPurify.sanitize(cleanedValue || '', {
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'style', 'form', 'input'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit'],
  });

  return { sanitized, hasBash, hasOtherDanger: hasDangerousContent };
}

